import React from "react";

import "./styles/testimonials.css";

// Real LinkedIn recommendations (deliberate, published endorsements, not
// out-of-context comments). Ordered strongest-for-positioning first: recent
// senior FinServ voices on empathy and growing people, then the
// technical-plus-leadership combo, then character.
const QUOTES = [
	{
		quote: "He leads with genuine empathy. He provided me with what I actually needed to grow and feel supported in my role. Any team would be lucky to have him.",
		name: "Jonathan Kalendareva",
		title: "Software Engineer, JPMorgan Chase",
		note: "Reported to Swapnil directly",
	},
	{
		quote: "One of the few who genuinely gets what it means to be both productive and empathetic as a manager. Any organization looking for a senior engineering leader will find someone who can actually grow people.",
		name: "Laura Alibrandi",
		title: "Advanced Scrum Master, Prudential",
		note: "His team's Scrum Master",
	},
	{
		quote: "Swap performed the roles of Senior Software Engineer, Tech Architect, and Product Manager seamlessly. This rare mix of productivity and ambition set a great example for the team.",
		name: "Jasdev Singh",
		title: "Director, GlassRatner",
		note: "Five years together at Vantage",
	},
	{
		quote: "He delivers the brainpower for a very broad range of challenges. But most of all, he cares about the people around him. He is genuinely trustworthy, and immensely wise.",
		name: "Jay Y. Kim",
		title: "Program Support Specialist, NJEDA",
		note: "Worked together at Vantage",
	},
];

const Testimonials = () => (
	<div className="homepage-section testimonials-section">
		<div className="homepage-section-head">
			<div className="homepage-section-title">What colleagues say</div>
		</div>
		<div className="testimonials-grid">
			{QUOTES.map((t) => (
				<figure className="testimonial-card" key={t.name}>
					<blockquote className="testimonial-quote">
						{t.quote}
					</blockquote>
					<figcaption className="testimonial-attr">
						<span className="testimonial-name">{t.name}</span>
						<span className="testimonial-title">{t.title}</span>
						<span className="testimonial-note">{t.note}</span>
					</figcaption>
				</figure>
			))}
		</div>
	</div>
);

export default Testimonials;
